// extracted by mini-css-extract-plugin
export var centerText = "_57-8";
export var container = "_57-0";
export var doughnutContainer = "_57-7";
export var legend = "_57-a";
export var legendItemColorDisplay = "_57-b";
export var legendItemLabel = "_57-d";
export var legendItemValue = "_57-c";
export var lg = "_57-5";
export var maxWidth = "_57-9";
export var md = "_57-4";
export var responsive = "_57-6";
export var sm = "_57-3";
export var xs = "_57-2";
export var xxs = "_57-1";